import style from "../blog.module.css";
import ExpandableText from "../TextoExpandible";
import React, { Suspense, lazy } from "react";
const InstagramEmbed = lazy(() =>
  import("react-social-media-embed").then((module) => ({
    default: module.InstagramEmbed,
  })),
);

const Semana: React.FC = () => {
  const Notice1 = `Las cuentas no cuadran, alcalde @alejoeder han pasado dos meses desde la tragedia y las ayudas del sector privado parecen embolatadas, mientras miles de familias siguen esperando ayudas reales tras el sismo.
De las 45.139 familias reportadas como damnificadas solo 9.035 han recibido algún tipo de ayuda económica, esto es una cifra INSUFICIENTE, las familias que perdieron todo necesitan respuestas, no titulares.

Alcalde menos show y más acción.`;
  return (
    <section className={style.Noticia}>
      <div className={style.Instagram}>
        <Suspense
          fallback={<div className="loading-placeholder">Loading...</div>}
        >
          <InstagramEmbed
            url="https://www.instagram.com/p/DeSBXyJJdwN/"
            width={328}
          />
        </Suspense>
      </div>
      <div className={style.Separador}></div>
      <div className={style.NoticeBox}>
        <h1 className={style.Tittle}>
          𝘿𝙤́𝙣𝙙𝙚 𝙚𝙨𝙩𝙖́𝙣 𝙡𝙤𝙨 𝙧𝙚𝙘𝙪𝙧𝙨𝙤𝙨 𝙥𝙖𝙧𝙖 𝙡𝙖 𝙧𝙚𝙘𝙤𝙣𝙨𝙩𝙧𝙪𝙘𝙘𝙞𝙤́𝙣 𝙙𝙚 𝘾𝙖𝙡𝙞❓🏚️🚨
        </h1>
        <h5 className={style.Fecha}>Octubre 09 del 2026</h5>
        <ExpandableText text={Notice1} limit={800} />
        <p className={style.reportero}>
          Oficina de Comunicaciones Concejal Rodrigo Salazar, Partido Alianza
          Verde 🌻{" "}
        </p>
      </div>
    </section>
  );
};

export default Semana;
